export default __webpack_public_path__ + "static/media/7-analytics.1e60b418.webp";